import * as React from 'react';

import DemoBlockedModal from './demoBlockedModal';
import { useDemoAccountContextProvider } from '../../contexts/DemoAccountContextProvider';
import { DataTable } from '../../../Shared/index';

type DataTableProps = React.ComponentProps<typeof DataTable>;

function isDragHandle(target: EventTarget) {
  return (target as HTMLElement).closest('[aria-roledescription="sortable"]') !== null;
}

const DemoGuardedDataTable: React.FC<DataTableProps> = (props) => {
  const { isDemo } = useDemoAccountContextProvider();
  const [showModal, setShowModal] = React.useState(false);

  const handleCloseModal = () => setShowModal(false);

  const handlePointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!isDemo || !isDragHandle(e.target)) return;
    setShowModal(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!isDemo || (e.key !== 'Enter' && e.key !== ' ') || !isDragHandle(e.target)) return;
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <div onKeyDown={handleKeyDown} onPointerDown={handlePointerDown}>
        <DataTable {...props} />
      </div>
      {showModal && <DemoBlockedModal onClose={handleCloseModal} />}
    </React.Fragment>
  );
};

export default DemoGuardedDataTable;
